import { render, staticRenderFns } from "./DescargarPlantilla.vue?vue&type=template&id=57ef63f8&scoped=true&"
import script from "./DescargarPlantilla.vue?vue&type=script&lang=js&"
export * from "./DescargarPlantilla.vue?vue&type=script&lang=js&"
import style0 from "./DescargarPlantilla.vue?vue&type=style&index=0&id=57ef63f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef63f8",
  null
  
)

export default component.exports